import { SpeakableScriptPart, SpeakableScriptPartType } from '../../main/types/asset/script.types.ts';
import { getLessonsUtil } from '../../main/utils/asset/lessons.util.ts';

export const mapSentenceToSpeakableScriptPart = (words: string[]): SpeakableScriptPart => {
  const pronunciations = words.map((word) => {
    const pronunciation = getLessonsUtil().getPronunciation(word);
    return pronunciation ?? word;
  });

  const textWithSpaces = pronunciations.join(' ');
  const text = textWithSpaces.endsWith('.') ? textWithSpaces : `${textWithSpaces}.`;

  return {
    type: SpeakableScriptPartType.Text,
    text,
  };
};
